import { TrancheModule } from "../utils/constant";
import { http } from "./http";
import { config } from "../configs/index";

export const loginApi = async (body) => {
  const data = await http.post("/login", body);
  return data;
};

export const forgotPasswordApi = async (body) => {
  const data = await http.post("/forgot-password", body);
  return data;
};
export const resetPasswordApi = async (body) => {
  const data = await http.put("/reset-password", body);
  return data;
};
export const getUserList = async (
  page = 1,
  isadmin = false,
  search = "",
  sort,
  role,
  limit = 10
) => {
  console.log("in the user list", sort);
  const data = await http.get("/admin-user", {
    params: {
      page,
      limit,
      isadmin,
      search,
      sort,
      role,
    },
  });
  return data;
};

export const getUserAuditLogs = async (targetId, page = 1, limit = 20) => {
  const data = await http.get("/users-audit-logs", {
    params: { targetId, page, limit },
  });
  return data;
};


export const getSubadminApi = async (
  page = 1,
  isadmin = false,
  search = ""
) => {
  const data = await http.get(
    `/subadmin?page=${page}&limit=${10}&isadmin=${isadmin}&search=${search}`
  );
  return data;
};

export const getSubadminAndAPIKey = async (page = 1, search) => {
  const data = await http.get(
    `/admins-and-active-api-keys?page=${page}&limit=${10}&search=${search}`
  );
  return data;
};

export const createSubadminApi = async (body) => {
  const data = await http.post("/subadmin", body);
  return data;
};

export const updateSubadminApi = async (id, body) => {
  const data = await http.put(`/subadmin/${id}`, body);
  return data;
};

export const deleteSubadminApi = async (id) => {
  const data = await http.delete(`/subadmin/${id}`);
  return data;
};

export const bulkUpdateSubadminApi = async (ids, update) => {
  const data = await http.patch("/subadmin/bulk", { ids, update });
  return data;
};

export const bulkDeleteSubadminApi = async (ids) => {
  const data = await http.delete("/subadmin/bulk", { data: { ids } });
  return data;
};

export const fetchFormData = async (model) => {
  const data = await http.get(`/constant?type=${model}`);
  return data;
};
export const sendFormData = async (body, modelId) => {
  const id = modelId;
  const data = await http.post(`/constant/${id}`, body);
  return data;
};
export const fetchStatesData = async () => {
  const data = await http.get(`/states`);
  return data;
};
export const sendStatesData = async (id, values) => {
  const data = await http.put(`/states/${id}`, values);
  return data;
};
export const verifyToken = async (token) => {
  const data = await http.get(`/verify-accesstoken/${token}`);
  return data;
};
export const subAdminProfile = async (body) => {
  const data = await http.put(`/profile-setup`, body);
  return data;
};
export const getReportData = async (currPage = 1, type, search) => {
  const data = await http.get(
    `/get-reports?page=${currPage}&limit=${10}&type=${type}&search=${search}`
  );
  return data;
};
export const generateReport = async () => {
  const data = await http.get(`/generate-report`);
  return data;
};

export const verifyAccount = async (zohoId) => {
  const data = await http.post(`/verify-account`, { zohoId });
  return data;
};

export const userReports = async (id, page) => {
  const data = await http.get(`/user-reports/${id}?page=${page}`);
  return data;
};

export const userInputs = async (id) => {
  const data = await http.get(`/user-input?id=${id}`);
  return data;
};

export const ReportDetails = async (id) => {
  const data = await http.get(`/detail-reports/${id}`);
  return data;
};

export const searchUser = async (query) => {
  const data = await http.get(`/user-list?search=${query}`);
  return data;
};

export const getUserInput = async (id) => {
  const data = await http.get(`/user-input?id=${id}`);
  return data;
};
export const updateUserInput = async (id, data) => {
  const userInputData = await http.put(`/user-input/${id}`, { data });
  return userInputData;
};
export const runReport = async (data) => {
  const userInputData = await http.post(`/report-generate`, data);
  return userInputData;
};

export const DownloadReport = async (id) => {
  const data = await http.get(`/download-report/${id}`, {
    responseType: "blob",
  });
  return data;
};

export const UpdateReport = async (body) => {
  const data = await http.post(`/report-updation`, body);
  return data;
};

export const DownloadStateMatrix = async () => {
  const data = await http.get(`/states/download`, {
    responseType: "blob",
  });
  return data;
};

export const CustomizationData = async () => {
  const data = await http.get(`/customization`);
  return data;
};

export const getNdaApi = async () => {
  const data = await http.get(`/nda`);
  return data;
};

export const updateNdaApi = async (body) => {
  const data = await http.put(`/nda`, body);
  return data;
};
export const updateUploadedStates = async (body) => {
  const data = await http.post(`/states/updateStates`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};
export const getEntityList = async (currentPage, itemsPerPage) => {
  const data = await http.get(
    `/get-entity-setup?page=${currentPage}&limit=${itemsPerPage}`
  );
  return data.data;
};

export const changeIsAllowed = async (body) => {
  //not used
  const data = await http.patch(`/toggle-entity-info`, body);
  return data;
};

export const updateReply = async (id, body) => {
  const data = await http.patch(`/reply/${id}`, body);
  return data;
};

export const addToAllowList = async (body) => {
  const data = await http.post(`/add-allow-list`, body);
  return data;
};
export const downloadLicence = async (body) => {
  const data = await http.post(`/download-driving-licence`, body, {
    responseType: "blob",
  });
  return data;
};

export const getAllowList = async () => {
  const data = await http.get(`/get-allow-list`);
  return data;
};

export const removeAllowList = async (id) => {
  const data = await http.get(`/remove-allow-list/${id}`);
  return data;
};

export const updateStatus = async (body) => {
  const data = await http.patch(`/set-entity-status`, body);
  return data;
};
export const updateEntityComment = async (body) => {
  const data = await http.patch(`/update-comment`, body);
  return data;
};
export const uploadFile = async (body) => {
  const data = await http.post(`/upload-attachment`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const bulkUploadThriveComments = async (file) => {
  const formData = new FormData();

  formData.append("file", file);

  const response = await http.post(
    "/m1m2-documents/bulk-upload-thrive-comments",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response;
};

export const getUserFlow = async (contactGroup, role) => {
  const data = await http.get(
    `/user-flow?contactGroup=${encodeURIComponent(contactGroup)}`
  );
  return data;
};
export const updateUserFlow = async (body) => {
  const data = await http.patch(`/user-flow`, body);
  return data;
};

export const getContactListByTranche = async (page, limit, searchTerm) => {
  const data = await http.get(
    `/user-flow/contact-list?page=${page}&limit=${limit}&searchTerm=${searchTerm}`
  );
  return data.data;
};

export const getContactAssetsByContact = async ({
  contactId,
  assetPage = 1,
  assetLimit = 10,
  assetSearchTerm = "",
}) => {
  const data = await http.get(
    `/user-flow/contact-assets?contactId=${contactId}&assetPage=${assetPage}&assetLimit=${assetLimit}&assetSearchTerm=${encodeURIComponent(
      assetSearchTerm
    )}`
  );
  return data;
};

export const updateContactAssetVisibility = async (body) => {
  const data = await http.patch(`/user-flow/contact-assets`, body);
  return data;
};

// Contact owner
export const getAllContactOwner = async (page, limit, sort) => {
  const params = { page, limit };
  if (sort && Object.keys(sort).length > 0) params.sort = JSON.stringify(sort);
  const data = await http.get(`/contact-owner`, { params });
  return data.data;
};
export const getContactOwner = async (id) => {
  const data = await http.get(`/contact-owner/${id}`);
  return data.data;
};
export const updateContactOwner = async (body) => {
  const data = await http.put(`/contact-owner`, body);
  return data.data;
};
export const deleteContactOwner = async (id) => {
  const data = await http.delete(`/contact-owner/${id}`);
  return data.data;
};

// proforma values
export const getProformaUser = async () => {
  const data = await http.get(`/get-proforma-values`);
  return data;
};
export const updateProformaValues = async (body) => {
  const data = await http.patch(`/update-proforma-values`, body);
  return data;
};

// Proforma user
export const registerProformaUser = async (body) => {
  const data = await http.post(`/proforma-user`, body);
  return data;
};
export const getProformaUsers = async (page, limit, sort) => {
  const data = await http.get(`/proforma-users`, {
    params: { page, limit, sort },
  });
  return data;
};
export const deleteProformaUser = async (id) => {
  const data = await http.delete(`/proforma-users/${id}`);
  return data;
};
export const editProformaUser = async (body) => {
  const data = await http.put(`/proforma-users`, body);
  return data;
};

// assets
export const getAllAssetsData = async (
  currentPage,
  itemsPerPage,
  searchTerm,
  dealName = 0,
  trancheTitle = 0
) => {
  const data = await http.get(
    `/assets?page=${currentPage}&limit=${itemsPerPage}&searchTerm=${searchTerm}&dealName=${dealName}&trancheTitle=${trancheTitle}`
  );
  return data.data;
};
export const getAssetsOmnidian = async () => {
  const data = await http.get(`/assets/prod-managed-by/omnidian`);
  return data;
};
export const uploadAssets = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const data = await http.post(`/assets`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};
export const uploadDuplicateAssets = async (body) => {
  const data = await http.post(`/add-duplicate-assets`, body);
  return data;
};
export const deleteAssets = async (id) => {
  const data = await http.delete(`/assets/${id}`);
  return data;
};
export const updateAssetRow = async (id, values) => {
  const data = await http.put(`/assets/${id}`, values);
  return data;
};

export const getAssetColumns = async (isDocument, role = "user") => {
  const data = await http.get("/asset/column", {
    params: { isDocument, role },
  });
  return data.data;
};

export const updateAssetAuditColumn = async (body) => {
  const data = await http.post(`/asset/update-columns-for-under-writer`, body);
  return data.data;
};

export const getAssetRows = async (params) => {
  const data = await http.get(`/asset/row`, {
    params: params,
  });
  return data.data;
};

export const getAssetProductionRows = async (params) => {
  const data = await http.get(`/asset/production-rows`, {
    params: params,
  });
  return data.data;
};

export const getContactAssets = async (params) => {
  const data = await http.get(`/contact/assets`, {
    params: params,
  });
  return data.data;
};

export const getAssetAuditRows = async (params) => {
  const data = await http.get(`/asset/row-audit-v2`, {
    params: params,
  });
  return data.data;
};

export const getGroupAssetRows = async (params) => {
  const data = await http.get(`/asset/group-assets`, {
    params: params,
  });

  return data.data;
};

export const getAssetZohoLabels = async () => {
  const data = await http.get(`/asset/zoho`);
  return data.data;
};

export const createAssetColumn = async (body) => {
  const data = await http.post(`/asset/column`, body);
  return data.data;
};

export const updateAssetColumn = async (id, body) => {
  const data = await http.put(`/asset/column/${id}`, body);
  return data.data;
};

export const deleteAssetColumn = async (id, sectionId) => {
  const data = await http.delete(`/asset/column/${id}/${sectionId}`);
  return data.data;
};

export const getAssetDocumentConditions = async (columnId) => {
  const data = await http.get(`/asset-document-conditions/${columnId}`);
  return data.data;
};

export const createAssetDocumentConditions = async (body) => {
  const data = await http.post(`/asset-document-conditions`, body);
  return data.data;
};

export const updateAssetDocumentConditions = async (id, body) => {
  const data = await http.put(`/asset-document-conditions/${id}`, body);
  return data.data;
};

export const deleteAssetRow = async (id, options = {}) => {
  const { deleteWithHistory = false } = options;

  const data = await http.delete(`/asset/row/${id}`, {
    data: { deleteWithHistory },
  });

  return data.data;
};

export const clearZohoFieldsInAsset = async (id) => {
  const data = await http.put(`/asset/row/clear/${id}`);
  return data.data;
};

export const uploadDuplicateAsset = async (body) => {
  const data = await http.post(`/asset/row/duplicate`, body);
  return data;
};

export const uploadAssetsData = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const data = await http.post(`/asset/row/file`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const updateAssetRowData = async (id, body) => {
  const data = await http.put(`/asset/row/${id}`, body);
  return data.data;
};

export const syncAssets = async () => {
  const data = await http.post(`/asset/zoho/push`);
  return data.data;
};

export const getAssetLogs = async (page, limit) => {
  const data = await http.get(`/asset-logs`, {
    params: {
      page,
      limit,
    },
  });
  return data.data;
};

export const getFailedAssetLogsCount = async (startDate, endDate) => {
  const data = await http.get(`/asset-logs/failed-count`, {
    params: { startDate, endDate },
  });
  return data.data;
};

export const getAssetFileVersionHistory = async (
  page = 1,
  limit = 10,
  assetId,
  colId
) => {
  const data = await http.get(`/asset-file-version-history`, {
    params: { page, limit, assetId, colId },
  });
  return data.data;
};

export const downloadFileVersion = async (versionId) => {
  const data = await http.get(
    `/asset-file-version-history/download/${versionId}`
  );
  return data.data;
};

export const downloadAssetCsv = async (id) => {
  const data = await http.get(`/asset-logs/asset-csv/${id}`);
  return data.data;
};

export const downloadErrorReport = async (id) => {
  const data = await http.get(`/asset-logs/error-report/${id}`);
  return data.data;
};

//baseline models
export const updateBaselineModelValues = async (id, values) => {
  const data = await http.put(`/baseline-model/${id}`, values);
  return data;
};
export const getBaselineModelValues = async (name) => {
  const data = await http.get(`/baseline-model`, {
    params: { name },
  });
  return data;
};

// Contact group
export const createContactGroup = async (values) => {
  const data = await http.post(`/contact-group`, values);
  return data;
};
export const updateContactGroup = async (values) => {
  const data = await http.put(`/contact-group`, values);
  return data;
};
export const getContactGroup = async () => {
  const data = await http.get(`/contact-group`);
  return data;
};
export const getContactGroupPaginated = async (page, limit, sort) => {
  const data = await http.get(`/contact-group-paginated`, {
    params: { page, limit, sort },
  });
  return data;
};
export const getPurlContactGroup = async () => {
  const data = await http.get(`/contact-group/purl`);
  return data.data;
};
export const deleteContactGroup = async (id) => {
  const data = await http.delete(`/contact-group/${id}`);
  return data;
};

export const updateContactGroupEmails = async (values) => {
  const data = await http.patch(`/contact-group`, values);
  return data;
};
export const deleteContactGroupEmails = async (id, values) => {
  const data = await http.delete(
    `/contact-group-email?id=${id}&email=${values}`
  );
  return data;
};
export const ContactGroupEmails = async (values) => {
  const data = await http.patch(`/contact-group`, values);
  return data;
};

export const getAllProductionReportsData = async (
  currentPage,
  itemsPerPage,
  searchTerm,
  dealName = 0,
  monthYear = 0
) => {
  const data = await http.get(
    `/production-report?page=${currentPage}&limit=${itemsPerPage}&searchTerm=${searchTerm}&dealName=${dealName}&monthYear=${monthYear}`
  );
  return data.data;
};

export const getAssetTypeCount = async (params) => {
  const data = await http.get("/production-report-summary/asset-type-count", {
    params,
  });
  return data.data;
};

export const getAssetTypeV2Count = async (params) => {
  const data = await http.get(
    "/production-report-summary-v2/asset-type-count",
    { params }
  );
  return data.data;
};

// Upload production report
export const uploadProductionReport = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  // TODO: Add report type if needed in future (currently not in use)
  const data = await http.post(`/production-report`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

// Handle duplicate production reports
export const uploadDuplicateProductionReport = async (reports) => {
  const data = await http.post(`/add-duplicate-production-report`, { reports });
  return data;
};

// Update production report
export const updateProductionReportRow = async (id, values) => {
  const data = await http.put(`/production-report/${id}`, values);
  return data;
};

// Delete production report
export const deleteProductionReport = async (id) => {
  const data = await http.delete(`/production-report/${id}`);
  return data;
};

export const uploadSpecialReport = async (dealName, assetId, files) => {
  const formData = new FormData();
  formData.append("deal_name", dealName);
  formData.append("asset_id", assetId);
  files.forEach((file) => formData.append("file", file));

  const response = await http.post(
    "/production-report/special-uploads",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response;
};

//permission
export const getUserPermission = async () => {
  const data = await http.get(`/permission/user`);
  return data.data;
};

export const createAdminPermission = async (data) => {
  const res = await http.post(`/permission`, data);
  return res;
};

export const getAllAdminTasks = async (userId) => {
  const res = await http.get(`/permission/task?userId=${userId}`);
  return res;
};

export const getAdminTasksWithArchiveFilter = async (isArchived, userId) => {
  const params = new URLSearchParams();

  if (isArchived !== undefined) params.append("isArchived", isArchived);
  if (userId) params.append("userId", userId); // only if userId is truthy

  const res = await http.get(
    `/permission/get-tasks-with-archive-filter?${params.toString()}`
  );
  return res;
};

export const getAdminPermissionByUserIdAndTaskId = async (userId) => {
  const res = await http.get(`/permissions?userId=${userId}`);
  return res;
};

export const updateAdminPermission = async (id, payload) => {
  const res = http.put(`/permission/${id}`, payload);
  return res;
};

//Admin tasks api's:

export const createAdminTask = async (data) => {
  const res = await http.post(`/permission/task`, data);
  return res;
};

export const archiveAdminModule = async (data) => {
  const res = await http.post(`/permission/archive`, data);
  return res;
};

export const deleteAdminTask = async (id) => {
  const res = await http.delete(`/permission/task/${id}`);
  return res;
};

export const getTrancheBotData = async (id) => {
  const data = await http.get(`/tranche-bot/${id}`);
  return data;
};

export const getAllTrancheBotData = async () => {
  const data = await http.get(`/tranche-bot`);
  return data;
};

export const createTrancheBot = async (values) => {
  const data = await http.post(`/tranche-bot`, values);
  return data;
};

export const deleteTrancheBot = async (id) => {
  const data = await http.delete(`/tranche-bot/${id}`);
  return data;
};

export const getTrancheBotV2Opportunity = async () => {
  const data = await http.get(`/tranche-bot-v2`);
  return data;
};

export const cleanOpportunityCache = async () => {
  const data = await http.delete(`/tranche-bot-v2/cache`);
  return data;
};

export const getTrancheBotV2LogsData = async (id) => {
  const data = await http.get(`/tranche-v2/logs/${id}`);
  return data;
};

export const calculateOpportunities = async (opportunities) => {
  console.log("API: Sending opportunities:", opportunities);
  console.log("API: Request payload:", { opportunities });

  try {
    const data = await http.post(`/tranche-bot-v2/calculate`, {
      opportunities,
    });
    console.log("API: Response received:", data);
    return data;
  } catch (error) {
    console.error("API: Request failed:", error);
    throw error;
  }
};

export const isMatchedCalculationOpportunity = async () => {
  const data = await http.get(`/tranche-bot-v2/polling`);
  return data;
};

export const cancelOpportunityApi = async (opportunityId) => {
  const data = await http.delete("/cancel-opportunity", {
    data: { opportunityId },
  });
  return data;
};

export const tranchePolling = async () => {
  const data = await http.get(`/tranche-bot/polling`);
  return data.data;
};

export const updateAssetsStatus = async (assetRowIds, assetColumnId, value) => {
  await http.patch(`/assets/update-status`, {
    assetRowIds,
    assetColumnId,
    value,
  });
};

export const uploadAssetDocument = async (file, assetId, colId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("colId", colId);
  formData.append("assetId", assetId);
  const data = await http.post(`/asset/file/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const removeAssetDocument = async (assetId, colId, reason = "") => {
  const data = await http.delete(`/asset/file/remove`, {
    data: { assetId, colId, ...(reason ? { reason } : {}) },
  });
  return data;
};

export const getAllDealSource = async () => {
  const data = await http.get(`/assets/deal-source`);
  return data;
};
export const getAllAssetTypes = async () => {
  const data = await http.get(`/assets/asset-type`);
  return data;
};
export const reOrderAssetColumns = async (data) => {
  const res = await http.patch(`/asset/column/reorder`, data);
  return res;
};

export const getProductionReportFilesById = async (id) => {
  const data = await http.get(`/production-reports/files/${id}`);
  return data.data;
};

export const downloadProductionReportFile = async (id) => {
  const data = await http.get(`/production-reports/files/view/${id}`);
  return data.data;
};

export const syncProductionReportPdf = async (asset) => {
  const data = await http.post(`/production-reports/generate`, {
    assetId: asset,
  });
  return data.data;
};

export const isProductionReportsPdfSyncing = async () => {
  const data = await http.get(`/production-reports/polling`);
  return data.data;
};

export const addAssetSyncJob = async (assetId) => {
  const res = await http.post(
    `/asset/assets-sync`,
    {},
    {
      params: {
        assetId,
      },
    }
  );
  return res;
};

export const isAssetsSyncingRunning = async () => {
  const res = await http.get(`/asset/asset-sync/polling`);
  return res.data;
};

export const getProformaGenerations = async (
  currentPage,
  itemsPerPage,
  searchTerm = "",
  sort = {}
) => {
  const escapedSearchTerm = searchTerm
    ? searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    : "";
  const params = {
    page: currentPage,
    limit: itemsPerPage,
    searchTerm: escapedSearchTerm,
  };
  if (sort && Object.keys(sort).length > 0) params.sort = JSON.stringify(sort);

  const data = await http.get(`/proforma-generations`, { params });
  return data.data;
};
export const createProformaGenerationRecord = async (body) => {
  const res = await http.post(`/proforma-generations`, body);
  return res.data;
};
export const createApiKey = async (body) => {
  const res = await http.post(`/api-key`, body);
  return res.data;
};

export const getApiKey = async (page, limit, sort) => {
  const res = await http.get(`/api-key`, {
    params: {
      page,
      limit,
      sort,
    },
  });
  return res.data;
};

export const updateApiKey = async (id, body) => {
  const res = await http.put(`/api-key/${id}`, body);
  return res.data;
};

export const resetApiKey = async (id) => {
  const res = await http.patch(`/api-key/${id}`);
  return res.data;
};

export const deleteApiKey = async (id) => {
  const res = await http.delete(`/api-key/${id}`);
  return res.data;
};

export const createEmailAddress = async (body) => {
  const res = await http.post(`/email-address`, body);
  return res.data;
};

export const getEmailAddress = async (page, limit, type) => {
  const res = await http.get(`/email-address`, {
    params: {
      page,
      limit,
      type,
    },
  });
  return res.data;
};

export const updateEmailAddress = async (id, body) => {
  const res = await http.put(`/email-address/${id}`, body);
  return res.data;
};

export const deleteEmailAddress = async (id) => {
  const res = await http.delete(`/email-address/${id}`);
  return res.data;
};

export const getAssetHistory = async (
  page,
  limit,
  assetId,
  colId,
  status,
  changeType,
  userId,
  createdFrom
) => {
  const res = await http.get(`/asset-history`, {
    params: {
      page,
      limit,
      assetId,
      colId,
      status,
      changeType,
      userId,
      createdFrom,
    },
  });
  return res.data;
};

export const createAssetFlag = async (body) => {
  const res = await http.post(`/asset-flags`, body);
  return res.data;
};

export const updateAssetFlag = async (id, body) => {
  const res = await http.put(`/asset-flags/${id}`, body);
  return res.data;
};

export const getAssetFlags = async (page, limit) => {
  const res = await http.get(`/asset-flags`, {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

export const deleteAssetFlag = async (id) => {
  const res = await http.delete(`/asset-flags/${id}`);
  return res.data;
};

export const getAssetFlagMark = async (id) => {
  const res = await http.get(`/asset-flag-mark`, {
    params: {
      id,
    },
  });
  return res.data;
};

export const getTsaAssetData = async (
  page,
  limit,
  search = "",
  sortBy = "createdAt",
  sortOrder = "desc"
) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sortBy: sortBy,
    sortOrder: sortOrder,
  });

  // Add search parameter if provided
  if (search && search.trim()) {
    params.append("search", search.trim());
  }

  const res = await http.get(`/all-assets-billing?${params.toString()}`);
  return res.data;
};

// export const exportTsaBillingDataToXLSX = async (params = {}) => {
//   try {
//     console.log("Calling export TSA billing API with params:", params);

//     // Build query parameters - NO page/limit for export
//     const queryParams = new URLSearchParams();

//     if (params.search && params.search.trim()) {
//       queryParams.append("search", params.search.trim());
//       console.log("Adding search parameter:", params.search.trim());
//     }

//     if (params.sortBy) {
//       queryParams.append("sortBy", params.sortBy);
//     }

//     if (params.sortOrder) {
//       queryParams.append("sortOrder", params.sortOrder);
//     }

//     if (params.assetIds) {
//       queryParams.append("assetIds", params.assetIds);
//     }

//     console.log("Final query string:", queryParams.toString());

//     // Use your existing http service with responseType: 'blob'
//     const response = await http.get(
//       `/tsa-billing/export?${queryParams.toString()}`,
//       {
//         responseType: "blob", // Critical for file downloads
//       }
//     );

//     console.log("Response received, size:", response.data.size);

//     // Get filename from response headers
//     // const contentDisposition =
//     //   response.headers["content-disposition"] ||
//     //   response.headers["Content-Disposition"];
//     // let filename = `TSA_Billing_Data_${new Date()
//     //   .toISOString()
//     //   .slice(0, 19)
//     //   .replace(/:/g, "-")}.xlsx`;
//     const contentDisposition =
//       response.headers["content-disposition"] ||
//       response.headers["Content-Disposition"];
//     let filename = `TSA_Billing_Data_${new Date()
//       .toISOString()
//       .slice(0, 19)
//       .replace(/:/g, "-")}.xlsx`;

//     if (contentDisposition) {
//       const filenameMatch = contentDisposition.match(
//         /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
//       );
//       if (filenameMatch) {
//         filename = filenameMatch[1].replace(/['"]/g, "");
//       }
//     }

//     console.log("Download filename:", filename);

//     // Create download
//     const blob = new Blob([response.data], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });

//     const downloadUrl = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = downloadUrl;
//     link.download = filename;
//     link.style.display = "none";

//     // Add to DOM, click, then remove
//     document.body.appendChild(link);
//     link.click();

//     // Clean up after download
//     setTimeout(() => {
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
//     }, 100);

//     console.log("File downloaded successfully:", filename);

//     return {
//       success: true,
//       filename: filename,
//       size: response.data.size,
//     };
//   } catch (error) {
//     console.error("Export failed:", error);
//     throw error;
//   }
// };

export const exportTsaBillingDataToXLSX = async (params = {}) => {
  const res = await http.get(`/tsa-billing/export`, {
    params,
  });

  return res?.data;
};

export const reportCenterExport = async (jobName) => {
  const response = await http.post(`reports-center/export`, { jobName });
  return response?.data;
};

export const reportCenterExportPolling = async (jobId) => {
  if (!jobId) return { jobId: "" };
  const response = await http.get(`reports-center/export/polling`, {
    params: { jobId },
  });
  return response?.data;
};

export const downloadAssetDocumentData = async (report_center = false) => {
  const response = await http.get(
    `/asset-document/export?report_center=${report_center}`
  );
  return response.data;
};

export const calculateTSABilling = async (assetId) => {
  const res = await http.post("tsa-billing/calculate-all", { assetId });
  return res.data;
};
export const createTsaType = async (body) => {
  const res = await http.post(`/tsa-billing-types`, body);
  return res.data;
};

export const getTsaBillingTypes = async ({
  page = 1,
  limit = 10,
  search = "",
  isActive,
  sortBy = "tsaType",
  sortOrder = "asc",
} = {}) => {
  const res = await http.get("/tsa-billing-types", {
    params: {
      page,
      limit,
      search,
      isActive,
      sortBy,
      sortOrder,
    },
  });
  return res.data;
};

// Get a single TSA billing type by ID
export const getTsaBillingTypeById = async (id) => {
  const res = await http.get(`/tsa-billing-types/${id}`);
  return res.data;
};

// Delete (soft delete) a TSA billing type by ID
export const deleteTsaBillingType = async (id) => {
  const res = await http.delete(`/tsa-billing-types/${id}`);
  return res.data;
};

export const updateTsaBillingType = async (id, data) => {
  const res = await http.put(`/tsa-billing-types/${id}`, data);
  return res.data;
};

export const addTranches = async (trancheData) => {
  const res = await http.post(`/tranches`, trancheData);
  return res.data;
};

export const fetchTranches = async (params) => {
  const res = await http.get("/tranches", { params });
  return res.data; // Returns { data: { data: [...], totalDocs }, message, success }
};

export const fetchTrancheAssets = async (trancheId, params = {}) => {
  const res = await http.get(`/tranches/${trancheId}/assets`, { params });
  return res.data; // Returns { data: { assets: [...], totalDocs }, message, success }
};

export const attachAssetRowToTranches = async ({
  trancheId,
  assetIds,
  forceAttach = false,
}) => {
  const res = await http.post(`/attach-asset-tranches`, {
    trancheId,
    assetIds,
    forceAttach,
  });
  return res.data;
};

export const deleteTranche = async (trancheId) => {
  const res = await http.delete(`/tranches/${trancheId}`);
  return res.data;
};

export const updateTranche = async (trancheId, body) => {
  const res = await http.put(`/tranches/${trancheId}`, body);
  return res.data;
};

// critical assets
export const getCriticalAssets = async (params) => {
  const res = await http.get(`/critical-assets`, {
    params: {
      page: params?.page || 1,
      limit: params?.limit || 10,
      searchTerm: params?.searchTerm,
      recordType: params?.recordType,
    },
  });
  return res.data;
};

export const acceptCriticalAssets = async (criticalAssetIds) => {
  const res = await http.post(`/critical-assets/approve`, {
    criticalAssetIdsData: criticalAssetIds,
  });
  return res.data;
};

// for the underwriting critical asset acceptance
export const acceptCriticalAssetUnderwriting = async (criticalAssetIds) => {
  const res = await http.post(`/asset/critical-asset-approve`, {
    criticalAssetIdsData: criticalAssetIds,
  });
  return res.data;
};

export const deleteCriticalAsset = async (ids) => {
  const res = await http.delete(`/critical-assets`, { params: { ids: ids } });
  return res.data;
};

export const getAssetFileDetails = async (assetId) => {
  const res = await http.get(`/asset-file-details/${assetId}`);
  return res.data;
};

export const getTrancheDocument = async (trancheId) => {
  const res = await http.get(`/tranche-file-details/${trancheId}`);
  return res.data;
};

export const getDownloadAssetFileDetails = async (assetId, config = {}) => {
  const res = await http.get(`/asset-file-download/${assetId}`, config);
  return res.data;
};

export const updateAssetFileDetails = async (assetId, data) => {
  const res = await http.put(`/asset-file-details/${assetId}`, data);
  return res.data;
};

export const updateAssetAuditDocuments = async (assetId, data) => {
  const res = await http.post(`/asset/audit-document-updates`, {
    ...data,
    assetId,
  });
  return res.data;
};

export const addThriveComments = async (assetId, data) => {
  const res = await http.post(`/asset/audit-document-thrive-comments`, {
    assetId,
    ...data,
  });
  return res.data;
};

export const isAssetFilesJobRunning = async (assetId) => {
  const res = await http.get(`/asset-file-job-running/${assetId}`);
  return res.data;
};

export const getIssueAssetFileDetails = async (assetId, colId) => {
  const res = await http.get(`/asset-file-failure-details/`, {
    params: {
      assetId,
      colId,
    },
  });
  return res.data;
};

export const getBaseLineModels = async () => {
  const data = await http.get(`/baseline-models`);
  return data.data;
};

export const getTrancheHistory = async ({
  page = 1,
  limit = 10,
  trancheId,
  moduleName,
} = {}) => {
  const res = await http.get("/tranche-history", {
    params: {
      page,
      limit,
      trancheId,
      moduleName,
    },
  });
  return res.data;
};

export const sendTrancheForApproval = async (trancheId) => {
  const res = await http.patch(
    `/tranche-bot-v2/${trancheId}/send-for-approval`
  );
  return res.data;
};

export const createTrancheV2 = async (body) => {
  const res = await http.post(`/tranche-bot-v2`, body);
  return res.data;
};

export const cancelTrancheV2 = async (trancheId) => {
  const res = await http.patch(`/tranche-bot-v2/${trancheId}/cancel`);
  return res.data;
};

export const approvedTranch = async (trancheId) => {
  const res = await http.patch(`/tranche-bot-v2/${trancheId}/approve`);
  return res.data;
};

export const rejectTranch = async (trancheId, data) => {
  const res = await http.patch(`/tranche-bot-v2/${trancheId}/reject`, data);
  return res.data;
};

// Get all tranches with pagination
export const getAllTranchesV2 = async ({
  page = 1,
  limit = 10,
  search = "",
  date = "",
  showAll = false,
  moduleName = TrancheModule.TRANCHE_BOT,
}) => {
  const res = await http.get(`/tranche-bot-v2/tranches`, {
    params: { page, limit, search, date, showAll, moduleName },
  });
  return res.data;
};

// Get single tranche by ID
export const getTrancheByIdV2 = async (trancheId) => {
  const res = await http.get(`/tranche-bot-v2/tranches`, {
    params: { trancheId },
  });
  return res.data;
};

export const getSyncLogs = async (page, limit, status) => {
  const res = await http.get(`/sync-logs`, {
    params: {
      page,
      limit,
      status,
    },
  });
  return res.data;
};

export const createAssetDocumentSection = async (payload) => {
  const res = await http.post(`/sections`, payload);
  return res.data;
};

// ➡️ Get all sections (with populated columns)
export const getAllAssetDocumentSections = async () => {
  const res = await http.get(`/sections`);
  return res.data;
};

export const getAllDocumentSectionByAssetId = async (assetId) => {
  const res = await http.get(`/sections/asset/${assetId}`);
  return res.data;
};
export const getAllTrancheDocument = async () => {
  const res = await http.get(`/tranche-doc-col`);
  return res.data;
};

// ➡️ Update section name
export const updateAssetDocumentSectionName = async (sectionId, data) => {
  const res = await http.put(`/sections/${sectionId}`, data);
  return res.data;
};

// ➡️ Delete a section
export const deleteAssetDocumentSection = async (sectionId) => {
  const res = await http.delete(`/sections/${sectionId}`);
  return res.data;
};

// Reorder asset document section
export const reorderAssetDocumentSection = async (data) => {
  const res = await http.put(`/sections`, data);
  return res.data;
};

// ➡️ Attach a column to a section
export const attachColumnToAssetDocumentSection = async (
  sectionId,
  columnId
) => {
  const res = await http.post(`/sections/attach-column`, {
    sectionId,
    columnId,
  });
  return res.data;
};

export const reOrderAssetDocumentColumns = async (data) => {
  const res = await http.patch(`/asset-document/column/reorder`, data);
  return res;
};

export const transferAssetColumnBetweenSections = async (payload) => {
  const response = await http.patch("/asset-document/column/transfer", payload);
  return response.data;
};

// Get single tranche by ID
export const getTrancheById = async (trancheId) => {
  const res = await http.get(`/tranche-bot-v2/${trancheId}`);
  return res.data;
};
export const markAssetReplacementOnZoho = async (data) => {
  const res = await http.post(`/asset/replacement`, data);
  return res;
};

export const lockUnlockAssetFields = async (assetId, columnId) => {
  const res = await http.put(`/asset/row/${assetId}/lock-unlock-fields`, {
    columnId,
  });
  return res.data;
};

export const exportAsset = async (params = {}) => {
  const res = await http.get(`/asset/export`, {
    params,
  });
  return res.data;
};

export const exportProductionReport = async (params = {}) => {
  const res = await http.get(`/production-report/export`, {
    params,
  });
  return res.data;
};

export const getApprovedMonths = async (params) => {
  const data = await http.get(`/production-report-month-year`, { params });
  return data.data;
};

export const createApprovedMonth = async (body) => {
  const data = await http.post(`/production-report-month-year`, body);
  return data.data;
};

export const deleteApprovedMonth = async (id) => {
  const data = await http.delete(`/production-report-month-year/${id}`);
  return data.data;
};

// export const getAssetApis = async () => {
//   const res = await http.get(`/asset-apis`);
//   return res.data;
// };

// export const deleteAssetApi = async (id) => {
//   const res = await http.delete(`/asset-apis/${id}`);
//   return res.data;
// };
export const callCorrectionRequestAPI = async (assetId, body) => {
  const res = await http.post(
    `/asset-apis/${assetId}/correction-request`,
    body
  );
  return res.data;
};

export const getCorrectionMessagesAPI = async (assetId) => {
  const res = await http.get(
    `/asset-apis/${assetId}/correction-requests-message`
  );
  return res.data;
};

export const updateCorrectionMessageAPI = async (assetId, body) => {
  const res = await http.patch(
    `/asset-apis/${assetId}/correction-requests-message`,
    body
  );
  return res.data;
};

export const callRePullAssetApi = async (assetIds) => {
  const res = await http.post(`/asset-apis/re-pull`, {
    assetIds,
  });
  return res.data;
};

export const uccDataPushApi = async (assetIds) => {
  const res = await http.post(`/asset-apis/ucc-data-push`, {
    assetIds,
  });
  return res.data;
};

export const addAssetApi = async (data) => {
  const res = await http.post("/asset-apis", data);
  return res.data;
};

// Update an existing Asset API
export const updateAssetApi = async (id, data) => {
  const res = await http.put(`/asset-apis/${id}`, data);
  return res.data;
};

// Get all Asset APIs
export const getAssetApis = async (isDocument = false) => {
  const res = await http.get(`/asset-apis?isDocument=${isDocument}`);
  return res.data;
};

// Get a single Asset API by ID
export const getAssetApiById = async (id) => {
  const res = await http.get(`/asset-apis/${id}`);
  return res.data;
};

// Soft delete an Asset API
export const deleteAssetApi = async (id) => {
  const res = await http.delete(`/asset-apis/${id}`);
  return res.data;
};

export const enableDisableBillOfSaleApi = async (id, isActive) => {
  const res = await http.put(`/activate-deactivate-asset-apis/${id}`, {
    isActive,
  });
  return res.data;
};

// Create BaseUrl
export const createBaseUrl = async (values) => {
  const data = await http.post("/base-url", values);
  return data;
};

// Update BaseUrl by ID
export const updateBaseUrl = async (id, values) => {
  const data = await http.patch(`/base-url/${id}`, values);
  return data;
};

// Get all BaseUrls
export const getBaseUrls = async () => {
  const data = await http.get("/base-url");
  return data;
};

// tranche bot v2 logs
export const getTrancheLogs = async ({ page = 1, limit = 10, trancheId }) => {
  const res = await http.get("/tranche-logs", {
    params: {
      page,
      limit,
      trancheId,
    },
  });
  return res.data;
};

// create tsa billing for an asset
export const createTsaBilling = async (id, isUpdate = false) => {
  const res = await http.post(
    `/tsa-billing/${id}`,
    {},
    {
      params: { isUpdate },
    }
  );
  return res.data;
};

export const getTrancheBotV2Analytics = async () => {
  const res = await http.get("/tranche-v2/analytics");
  return res.data;
};

export const getDashboardSummary = async () => {
  const res = await http.get("/dashboard/summary");
  return res.data;
};

export const uploadTrancheDocument = async (
  trancheId,
  colId,
  file,
  forceUpload = false
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("trancheId", trancheId);
  formData.append("colId", colId);
  formData.append("forceUpload", forceUpload);
  const data = await http.post(`/tranche/file/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const getAssetDocumentFileHistory = async ({
  trancheId,
  colId,
  page = 1,
  limit = 10,
}) => {
  const res = await http.get(
    `/asset-file-history?trancheId=${trancheId}&colId=${colId}&page=${page}&limit=${limit}`
  );
  return res.data;
};

export const getContact = async (id) => {
  const res = await http.get(`/contacts/${id}`);
  return res.data;
};

export const updateContact = async (id, data) => {
  const res = await http.post(`/contacts/${id}`, { data });
  return res.data;
};

export const deleteContact = async (id) => {
  const res = await http.delete(`/contacts/${id}`);
  return res.data;
};

export const getContacts = async ({
  page = 1,
  limit = 10,
  search,
  recordType,
  sort,
  year
}) => {
  const res = await http.get("/contacts", {
    params: {
      page,
      limit,
      search,
      recordType,
      sort,
      year
    },
  });
  return res.data;
};

export const getAllContactDocumentSections = async () => {
  const res = await http.get("/contacts/document/section");
  return res.data;
};

export const createContactDocumentSection = async (data) => {
  const res = await http.post("/contacts/document/section", data);
  return res.data;
};

export const updateContactDocumentSection = async (sectionId, data) => {
  const res = await http.put(`/contacts/document/section/${sectionId}`, data);
  return res.data;
};

export const deleteContactDocumentSection = async (sectionId) => {
  const res = await http.delete(`/contacts/document/section/${sectionId}`);
  return res.data;
};

export const attachDocumentsToContactsSection = async (contactId) => {
  const res = await http.get(
    `/contacts/document/section/attach-documents/${contactId}`
  );
  return res.data;
};

export const getAssetRowsHistory = async (page = 1, limit = 10, id) => {
  const data = await http.get(`/asset-row-history`, {
    params: {
      page,
      limit,
      id,
    },
  });
  return data.data;
};

export const createContactDocumentRow = async (
  sectionId,
  userId,
  file,
  parentFolderKey = null
) => {
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  }

  if (sectionId) {
    formData.append("sectionId", sectionId);
  }

  formData.append("userId", userId);

  if (parentFolderKey) {
    formData.append("parentFolderKey", parentFolderKey);
  }

  const { data } = await http.post(`/contacts/document/row`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};

export const getAllContactDocumentRowsByUserId = async (
  userId,
  parentFolderKey = null
) => {
  const res = await http.get(`/contacts/document/row/${userId}`, {
    params: { parentFolderKey },
  });
  return res.data;
};

export const updateContactDocumentRow = async (id, body) => {
  const res = await http.put(`/contacts/document/row/${id}`, body);
  return res.data;
};
export const getDownloadContactFileDetails = async (id) => {
  const res = await http.get(`/contacts-file-download/${id}`);
  return res.data;
};

export const overRideContactDocumentRowFile = async (data) => {
  const res = await http.put(`/contacts/upload-gl-override-document`, data);
  return res.data;
};

export const chekcedContactsDocumentDeleted = async (id) => {
  const res = await http.put(`/contacts/document/row/check-deleted/${id}`);
  return res.data;
};

export const getContactFileHistory = async ({
  documentId,
  page = 1,
  limit = 10,
}) => {
  const res = await http.get(
    `/contacts-file-history?documentId=${documentId}&page=${page}&limit=${limit}`
  );
  return res.data;
};

export const removeContactDocument = async (id) => {
  const res = await http.delete(`/contacts/document/row/${id}`);
  return res.data;
};

export const updateContactDocumentRowFile = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await http.put(`/contacts/document/row/file/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const downloadContactsData = async (
  searchTerm = "",
  report_center = false,
  recordType = ""
) => {
  const response = await http.get(
    `/get-export-contacts?searchTerm=${searchTerm}&report_center=${report_center}&recordType=${recordType}`
  );

  return response.data;
};

export const contactBulkDocumentSync = async () => {
  const response = await http.post("/contacts/document/bulk-attach-documents");
  return response.data;
};

export const uploadContactGLDocuments = async (data) => {
  const res = await http.post(`/contacts/upload-gl-document`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const uploadGLInsurance = async (data) => {
  const res = await http.post(`/upload-gl-insurance`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const insuranceDocumentJob = async (mappingFile, zipFile) => {
  const res = await http.post(`/insurance-document-job-start`, {
    mappingFile,
    zipFile,
  });
  return res.data;
};

export const checkInsuranceDocumentJob = async () => {
  const res = await http.get(`/insurance-document-job-check`);
  return res.data;
};

export const pandcDocumentJob = async (mappingFile, zipFile) => {
  const res = await http.post(`/pandc-document-job-start`, {
    mappingFile,
    zipFile,
  });
  return res.data;
};

export const checkPandCDocumentJob = async () => {
  const res = await http.get(`/pandc-document-job-check`);
  return res.data;
};

export const uploadPandCInsuranceDocument = async (data) => {
  const res = await http.post(`/upload-pandc-insurance`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const uploadPandCDocuments = async (data) => {
  const res = await http.post(`/assets/upload-pandc-document`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const overridePandCDocuments = async (data) => {
  const res = await http.put(`/pandc/upload-pandc-override-document`, data);
  return res.data;
};

export const getAllPandCDocumentSections = async () => {
  const res = await http.get("/assets/pandc-document/section");
  return res.data;
};

export const getAllPandCDocumentRowsByAssetId = async (assetId) => {
  const res = await http.get(`/assets/pandc-document/row/${assetId}`);
  return res.data;
};

export const createPandCDocumentRow = async (
  reportName,
  fileName,
  sectionId,
  assetId,
  file
) => {
  const formData = new FormData();
  formData.append("reportName", reportName);
  formData.append("sectionId", sectionId);
  formData.append("fileName", fileName);
  formData.append("assetId", assetId);
  formData.append("file", file);

  const { data } = await http.post(`/assets/pandc-document/row`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};

export const getDownloadPandCFileDetails = async (id) => {
  const res = await http.get(`/assets/pandc-document-file-download/${id}`);
  return res.data;
};

export const removePandCDocument = async (id, assetId) => {
  const res = await http.delete(`/assets/pandc-document/row/${id}`, {
    params: {
      assetId,
    },
  });
  return res.data;
};

export const getPandCFileHistory = async ({
  documentId,
  page = 1,
  limit = 10,
}) => {
  const res = await http.get(
    `/assets/pandc-document-file-history?documentId=${documentId}&page=${page}&limit=${limit}`
  );
  return res.data;
};

export const getReportCenterRows = async () => {
  const res = await http.get(`/reports-center`);
  return res.data;
};
export const addReportCenterRowEmail = async (id, email) => {
  const res = await http.patch(`/reports-center/${id}/add-emails`, {
    emails: email,
  });
  return res.data;
};

export const removeReportCenterRowEmail = async (id, email) => {
  const res = await http.patch(`/reports-center/${id}/remove-emails`, {
    emails: email,
  });
  return res.data;
};

export const getReportCenterLogs = async (id, page = 1, limit = 10) => {
  const res = await http.get(`/reports-center-logs/${id}`, {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

export const downloadTrancheData = async (
  searchTerm = "",
  report_center = false,
  recordType = "",
  moduleName = ""
) => {
  const response = await http.get(
    `/export-tranche-data?searchTerm=${searchTerm}&report_center=${report_center}&recordType=${recordType}&moduleName=${moduleName}`
  );

  return response.data;
};

export const getRejectedAssets = async (page = 1, limit = 10, search = "") => {
  const res = await http.get(`/rejected-assets`, {
    params: {
      page,
      limit,
      search,
    },
  });
  return res.data;
};

export const deleteRejectedAsset = async (id) => {
  const res = await http.delete(`/rejected-assets/${id}`);
  return res.data;
};

export const pullBosDocument = async (trancheID) => {
  const res = await http.get(`/tranche/pull-tranche-bos-document/${trancheID}`);
  return res.data;
};

export const createDivisorLookup = async (payload) => {
  const res = await http.post(`/divisor-lookup`, payload);
  return res.data;
};

export const fetchDivisorLookups = async (params) => {
  const res = await http.get(`/divisor-lookup`, { params });
  return res.data;
};

export const updateDivisorLookup = async (id, payload) => {
  const res = await http.patch(`/divisor-lookup/${id}`, payload);
  return res.data;
};

export const deleteDivisorLookup = async (id) => {
  const res = await http.delete(`/divisor-lookup/${id}`);
  return res.data;
};

export const getFeatureFlagsByKey = async (key) => {
  const res = await http.get(`/feature-flag`, {
    params: { key },
  });
  return res.data;
};

export const updateFeatureFlag = async (id, data) => {
  const res = await http.put(`/feature-flag/${id}`, data);
  return res.data;
};

export const getAllUnderWriters = async () => {
  const res = await http.get(`/asset/under-writers`);
  return res.data;
};

export const assignAssetUnderWriter = async (
  assetIds,
  underWriter,
  force = false
) => {
  const res = await http.post(`/asset/assign-under-writer`, {
    assetIds,
    userId: underWriter,
    force,
  });
  return res.data;
};

export const getAllRejectionReasons = async () => {
  const res = await http.get(`/asset/rejection-reasons`);
  return res.data;
};

export const markAssetAsRejected = async (
  assetIds,
  reasonId,
  rejectedReason
) => {
  const res = await http.post(`/asset/mark-as-rejected`, {
    assetIds,
    reasonId,
    rejectedReason,
  });
  return res.data;
};

export const getAssetRejectionDetails = async (assetId) => {
  const res = await http.get(`/asset/rejection-reasons/${assetId}`);
  return res.data;
};

// production report upload logs

export const getProductionReportUploadLogs = async (page, limit) => {
  const data = await http.get(`/production-report-upload-logs`, {
    params: {
      page,
      limit,
    },
  });
  return data.data;
};

export const downloadProductionReportCsv = async (id) => {
  const data = await http.get(
    `/production-report-upload-logs/file/production-report-csv/${id}`
  );
  return data.data;
};

export const downloadProductionReportErrorReport = async (id) => {
  const data = await http.get(
    `/production-report-upload-logs/file/error-report/${id}`
  );
  return data.data;
};

export const uploadProductionReportFile = async (
  documentId,
  assetId,
  file,
  month
) => {
  const formData = new FormData();

  if (documentId) {
    formData.append("documentId", documentId);
  }

  formData.append("assetId", assetId);
  formData.append("file", file);

  if (month) {
    formData.append("monthYear", month);
  }

  return http.post(`/production-report/file/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// production report dispatch logs

export const getProductionReportDispatchLogs = async (page, limit) => {
  const data = await http.get(`/production-report-dispatch-logs`, {
    params: {
      page,
      limit,
    },
  });
  return data.data;
};

export const getAuthUser = async () => {
  const data = await http.get(`/me`);
  return data.data;
};

export const updateProfile = async (body = {}) => {
  const data = await http.put(`/me`, body);
  return data.data;
};

export const changePassword = async (body = {}) => {
  const data = await http.put(`/change-password`, body);
  return data.data;
};
export const divisorLookupJob = async () => {
  const data = await http.post("/asset/divisor-mismatch-check");
  return data;
};

export const getTickets = async (
  page = 1,
  limit = 10,
  status = "All",
  searchTerm = "",
  priorities = "",
  tags = ""
) => {
  const data = await http.get(`/tickets`, {
    params: {
      page,
      limit,
      status,
      searchTerm,
      priorities,
      tags,
    },
  });
  return data.data;
};

export const getTags = async (page = 1, limit = 10, searchTerm = "") => {
  const data = await http.get(`/tickets/tags`, {
    params: {
      page,
      limit,
      searchTerm,
    },
  });
  return data.data;
};

export const getTicketById = async (id) => {
  const data = await http.get(`/tickets/${id}`);
  return data.data;
};

export const getPartnerDocumentList = async (page, limit, sort) => {
  const data = await http.get(`/partner/document/list`, {
    params: {
      page,
      limit,
      sort,
    },
  });
  return data.data;
};

export const uploadPartnerDocument = async (fileName, file, link) => {
  const formData = new FormData();
  formData.append("fileName", fileName);
  formData.append("file", file);
  formData.append("link", link);

  const { data } = await http.post(`/partner/document/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};

export const deletePartnerDocument = async (id) => {
  const { data } = await http.delete(`/partner/document/${id}`);
  return data;
};

export const updatePartnerDocumentFile = async (id, { file, fileName }) => {
  const formData = new FormData();
  if (file) formData.append("file", file);
  if (fileName) formData.append("fileName", fileName);

  const { data } = await http.put(`/partner/document/file/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};

// asset geocoding

export const getGeocodingLogs = async ({ page, limit, assetId }) => {
  const data = await http.get(`/asset-geocoding-logs`, {
    params: {
      page,
      limit,
      assetId,
    },
  });
  return data.data;
};

export const refreshAssetGeocoding = async ({ assetId }) => {
  const data = await http.put(`/asset/row/${assetId}/refresh-geocoding`);
  return data.data;
};

export const deleteAssetGeocodingLog = async ({ id }) => {
  const data = await http.delete(`/asset-geocoding-logs/${id}`);
  return data.data;
};

// TODO - REMOVE THIS API AFTER PRODUCTION MONITORING IS FINALIZED
// export const uploadProductionReportsData = async (
//   file,
//   templateType = "hdm"
// ) => {
//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("templateType", templateType);
//   const data = await http.post(`/production-reporting/upload`, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
//   return data;
// };

// production report v2

export const getProductionReportSummary = async (params) => {
  // { page = 1, limit = 10, search, searchBy, month, year, type, assetType, dealSource, dataQuality, reportType, contactId, groupBy }
  const data = await http.get(`/production-report-summary`, {
    params: params,
  });
  return data.data;
};

export const getProductionReportSummaryStats = async (params) => {
  const data = await http.get(`/production-report-summary/stats`, {
    params: params,
  });
  return data.data;
};

export const getProductionReportSummaryV2 = async (params) => {
  // { page = 1, limit = 10, search, searchBy, month, year, type, assetType, dealSource, dataQuality, reportType, contactId, groupBy }
  const data = await http.get(`/production-report-summary-v2`, {
    params: params,
  });
  return data.data;
};

export const getProductionReportSummaryV2Stats = async (params) => {
  const data = await http.get(`/production-report-summary-v2/stats`, {
    params: params,
  });
  return data.data;
};

export const exportProductionReportSummaryV2 = async (params) => {
  const data = await http.get(`/production-report-summary-v2/export`, {
    params: params,
  });
  return data.data;
};

export const getProductionReportDataSummary = async (params) => {
  // { page = 1, limit = 10, search, searchBy, month, year, type, assetType, dealSource, dataQuality, reportType, contactId, groupBy }
  const data = await http.get(`/production-report-summary/monitoring-data`, {
    params: params,
  });
  return data.data;
};

export const getEstimatedProductionReports = async (params) => {
  const data = await http.get(`/production-report-summary/estimated`, {
    params: params,
  });
  return data.data;
};
export const generateProductionReportPdf = async (productionReportIds) => {
  const data = await http.post(`/production-report-summary/generate`, {
    productionReportIds: productionReportIds,
  });
  return data.data;
};

export const generateProductionReportPdfV2 = async (productionReportIds) => {
  const data = await http.post(`/production-report-summary-v2/generate`, {
    productionReportIds: productionReportIds,
  });
  return data.data;
};

export const bulkMarkUploaded = async (payload) => {
  const data = await http.patch(`/production-report/bulk/mark-uploaded`, {
    records: payload,
  });
  return data.data;
};

export const bulkSendToClientPortal = async (payload) => {
  const data = await http.post(
    `/production-report/bulk/send-to-client-portal`,
    payload
  );
  return data.data;
};

export const generateInvestorDocumentApi = (
  contactId = "",
  jobName = "helperForm",
  targetYear = ""
) => {
  const data = http.post(`/investor-documents`, { contactId, jobName, targetYear });
  return data;
};

export const getGeneralLogs = async (params) => {
  const data = await http.get("/document-error-logs", { params });
  return data.data;
};

export const getTrancheDocumentApis = async () => {
  const res = await http.get(`/tranche-api`);
  return res.data;
};

export const addTrancheDocumentApi = async (data) => {
  const res = await http.post("/tranche-api", data);
  return res.data;
};

export const updateTrancheDocumentApi = async (id, data) => {
  const res = await http.put(`/tranche-api/${id}`, data);
  return res.data;
};

export const deleteTrancheDocumentApi = async (id) => {
  const res = await http.delete(`/tranche-api/${id}`);
  return res.data;
};

export const getAllApiEndpoints = async (query = {}) => {
  const params = new URLSearchParams();
  if (query.page) params.append("page", query.page);
  if (query.limit) params.append("limit", query.limit);
  if (query.isZohoAPI !== undefined)
    params.append("isZohoAPI", query.isZohoAPI);
  const res = await http.get(`/api-endpoints?${params.toString()}`);
  return res.data;
};

export const getApiEndpointById = async (id) => {
  const res = await http.get(`/api-endpoints/${id}`);
  return res.data;
};

export const getApiEndpointByZohoKey = async (zohoKey) => {
  const res = await http.get(`/api-endpoints/zoho/${zohoKey}`);
  return res.data;
};
export const generateEstimatedProductionReport = async (assetId = "") => {
  const data = await http.get(
    `/asset-v2/generate-estimated-production-report?assetId=${assetId}`
  );
  return data.data;
};
export const generateEstimatedProductionReportV2 = async (assetId = "") => {
  const data = await http.get(
    `/production-report-rows/estimated-production-report-v2?assetId=${assetId}`
  );
  return data.data;
};

export const isEstimatedProductionReportRunningV2 = async () => {
  const data = await http.get(
    `/production-report-rows/is-estimate-production-report-v2-running`
  );
  return data.data;
};

export const isEstimateProductionReportRunning = async () => {
  const data = await http.get(
    "/asset-v2/generate-estimated-production-report/running"
  );
  return data;
};

export const deleteProductionReportFile = async (id) => {
  const data = await http.delete(`/production-report/file/${id}`);
  return data.data;
};

export const downloadAssetEstimationProductionReport = async (
  report_center = false
) => {
  const response = await http.get(
    `/get-estimated-production-report?report_center=${report_center}`
  );
  return response.data;
};
export const downloadTemplateApi = async () => {
  const data = await http.get(`/api/proforma/template/download`, {
    baseURL: config.REACT_APP_PROFORMA_GENERATOR_MICROSERVICE_BASE_URL,
    responseType: "blob",
  });
  return data;
};

export const uploadTemplateApi = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const data = await http.post(`/api/proforma/template/upload`, formData, {
    baseURL: config.REACT_APP_PROFORMA_GENERATOR_MICROSERVICE_BASE_URL,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const getPvWattsEstimatesApi = async (assetId, page = 1, limit = 10) => {
  try {
    const response = await http.get("/pvwatts-estimates", {
      params: {
        assetId: assetId,
        page: page,
        limit: limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching PV Watts Estimates:", error);
    throw error;
  }
};

export const toggleChatBot = async (id) => {
  const data = await http.patch(`/contacts/${id}/chat-bot`);
  return data.data;
};

export const getPvWattsEstimatesLogs = async (page = 1, limit = 10) => {
  const data = await http.get(`/pvwatts-estimates-logs`, {
    params: {
      page,
      limit,
    },
  });
  return data.data;
};

export const deletePvWattsEstimatesLog = async (id) => {
  const data = await http.delete(`/pvwatts-estimates-logs/${id}`);
  return data.data;
};

export const refreshPvWattsEstimate = async ({ assetId }) => {
  const data = await http.put(
    `/pvwatts-estimates-logs/retry-pvwatts/${assetId}`
  );
  return data.data;
};

export const getProductionReportFile = async (
  assetId,
  monthYear,
  version = "v1"
) => {
  const data = await http.get(
    `/production-report/file?assetId=${assetId}&monthYear=${monthYear}&version=${version}`
  );
  return data.data;
};

export const getProductionReportV2Columns = async () => {
  const data = await http.get("/production-report-columns");
  return data.data;
};

export const createProductionReportV2Column = async (body) => {
  const data = await http.post("/production-report-columns", body);
  return data.data;
};

export const updateProductionReportV2Column = async (id, body) => {
  const data = await http.put(`/production-report-columns/${id}`, body);
  return data.data;
};

export const deleteProductionReportV2Column = async (id) => {
  const data = await http.delete(`/production-report-columns/${id}`);
  return data.data;
};

export const reOrderProductionReportV2Columns = async (body) => {
  const data = await http.patch("/production-report-columns/reorder", body);
  return data.data;
};

export const getAllProductionReportsV2Data = async (
  currentPage,
  itemsPerPage,
  searchTerm
) => {
  const data = await http.get("/production-report-rows", {
    params: {
      page: currentPage,
      limit: itemsPerPage,
      searchTerm,
    },
  });
  return data.data;
};

export const uploadProductionReportV2 = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return http.post("/production-report-rows/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateProductionReportV2Row = async (id, body) => {
  const data = await http.put(`/production-report-rows/${id}`, body);
  return data.data;
};

export const deleteProductionReportV2 = async (id) => {
  const data = await http.delete(`/production-report-rows/${id}`);
  return data.data;
};

export const exportProductionReportV2 = async (params = {}) => {
  const data = await http.get("/production-report-rows/export", {
    params,
  });
  return data.data;
};

export const uploadSpecialReportv2 = async (dealName, assetId, files) => {
  const formData = new FormData();
  formData.append("deal_name", dealName);
  formData.append("asset_id", assetId);
  files.forEach((file) => formData.append("file", file));

  return http.post("/production-report-rows/special-upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getProductionReportFlags = async (id) => {
  const res = await http.get(`/production-report-summary/${id}/flags`);
  return res.data;
};

export const exportProductionReportSummary = async (params = {}) => {
  const res = await http.get(`/production-report-summary/export`, {
    params,
  });
  return res.data;
};

export const getProductionReportV2Flags = async (id) => {
  const res = await http.get(`/production-report-summary-v2/${id}/flags`);
  return res.data;
};

export const exportEnergizedAssetMissingPvWatts = async (params = {}) => {
  const res = await http.get(
    `/production-report-summary/export/energized-asset-missing-pvwatts`,
    {
      params,
    }
  );
  return res.data;
};

export const getProductionReportFlagDefinitions = async (source) => {
  const res = await http.get(`/production-report-flags`, {
    params: source ? { source } : {},
  });
  return res.data;
};

export const createProductionReportFlagDefinition = async (body) => {
  const res = await http.post(`/production-report-flags`, body);
  return res.data;
};

export const updateProductionReportFlagDefinition = async (id, body) => {
  const res = await http.put(`/production-report-flags/${id}`, body);
  return res.data;
};

export const deleteProductionReportFlagDefinition = async (id) => {
  const res = await http.delete(`/production-report-flags/${id}`);
  return res.data;
};

export const getUploadClientPortalCount = async (params) => {
  const res = await http.get(`/production-report-summary/client-portal-count`, {
    params,
  });
  return res.data;
};

export const getUploadClientPortalCountV2 = async (params) => {
  const res = await http.get(
    `/production-report-summary-v2/client-portal-count`,
    { params }
  );
  return res.data;
};

export const getProductionReportStatusCountV2 = async () => {
  const res = await http.get(`/production-report-summary-v2/status-count`);
  return res.data;
};

export const getDistinctDealerStatusOptions = async () => {
  const res = await http.get(`/production-report-rows/dealer-status-options`);
  return res.data;
};

export const bulkMarkUploadedV2 = async (payload) => {
  const data = await http.patch(
    `/production-report-summary-v2/bulk/mark-uploaded`,
    {
      records: payload,
    }
  );
  return data.data;
};

export const bulkSendToClientPortalV2 = async (payload) => {
  const data = await http.post(
    `/production-report-summary-v2/bulk/send-to-client-portal`,
    payload
  );
  return data.data;
};

export const bulkUpdateProductionReportSummaryStatus = async (payload) => {
  const data = await http.patch(
    `/production-report-summary-v2/summary/status/bulk`,
    payload
  );
  return data.data;
};

export const getProductionReportDataSummaryV2 = async (params) => {
  // { page = 1, limit = 10, search, searchBy, month, year, type, assetType, dealSource, dataQuality, reportType, contactId, groupBy }
  const data = await http.get(`/production-report-summary-v2/monitoring-data`, {
    params: params,
  });
  return data.data;
};

export const generateBulkProductionReport = async (body) => {
  const data = await http.post(
    `/production-report-summary/generate-month-year`,
    body
  );
  return data;
};

export const generateBulkProductionReportV2 = async (body) => {
  const data = await http.post(
    `/production-report-summary-v2/generate-month-year`,
    body
  );
  return data;
};
export const updateProductionReportSummaryStatus = async (id, data) => {
  const response = await http.patch(
    `/production-report-summary-v2/summary/${id}/status`,
    data
  );

  return response.data;
};

// purl folder map

export const getPurlFolderMap = async ({ key, parentId }) => {
  const data = await http.get(`/purl-folder-map`, {
    params: { key, parentId },
  });
  return data.data;
};

// purl folder permissions

export const getPurlFolderPermissions = async ({
  contactGroup,
  key,
  parentId,
}) => {
  const data = await http.get(`/purl-folder-permissions`, {
    params: { contactGroup, key, parentId },
  });
  return data.data;
};

export const updatePurlFolderPermissions = async ({
  contactGroup,
  role,
  folderId,
  allowed,
}) => {
  const data = await http.put(`/purl-folder-permissions`, {
    contactGroup,
    role,
    folderId,
    allowed,
  });
  return data.data;
};

export const getDistinctTranches = async (
  page = 1,
  limit = 10,
  searchTerm = ""
) => {
  const data = await http.get(`/tranche-sold`, {
    params: {
      page,
      limit,
      searchTerm,
    },
  });
  return data.data;
};

export const getPurlMarketingResources = async ({
  page,
  limit,
  module,
  search,
  sort,
}) => {
  const data = await http.get(`/purl-marketing-resources`, {
    params: {
      page,
      limit,
      module,
      search,
      sort,
    },
  });
  return data.data;
};

export const syncDataToPowerBI = async (data) => {
  const res = await http.post("/power-bi/add-job", data);
  return res.data;
};

export const getPurlMarketingResourceVersions = async ({
  module,
  key,
  page,
  limit,
}) => {
  const data = await http.get(`/purl-marketing-resources/version-all`, {
    params: { module, key, page, limit },
  });
  return data.data;
};

export const updatePurlMarketingResourceVersion = async (body) => {
  const data = await http.put(`/purl-marketing-resources/version-update`, body);
  return data.data;
};

export const getPurlMarketingPublicUrl = async (key) => {
  const data = await http.get(`/purl-marketing-resources/public-url`, {
    params: { key },
  });
  return data.data;
};

export const createPurlMarketingResource = async (formData) => {
  const data = await http.post(`/purl-marketing-resources`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data.data;
};

export const getPowerBiEmbedToken = async () => {
  const res = await http.get(`/power-bi/embed-token`);
  return res.data;
};

export const getPowerBiUserReports = async (
  folderId = "",
  search = "",
  limit = "",
  page = ""
) => {
  const res = await http.get(
    `/power-bi/reports?folderId=${folderId}&search=${search}&limit=${limit}&page=${page}`
  );
  return res.data;
};

export const getPowerBiUserReportsAll = async (
  folderId = "",
  search = "",
  limit = "",
  page = ""
) => {
  const res = await http.get(
    `/power-bi/reports/all?folderId=${folderId}&search=${search}&limit=${limit}&page=${page}`
  );
  return res.data;
};

export const getPowerBiFolders = async (params) => {
  const res = await http.get(`/power-bi-folders`, { params });
  return res.data;
};

export const getPowerBiFoldersAll = async (params) => {
  const res = await http.get(`/power-bi-folders/all`, { params });
  return res.data;
};
export const assignReportToSection = async (reportId, folderId) => {
  const res = await http.patch(`/power-bi-folders/reports/${reportId}/folder`, {
    folderId,
  });
  return res.data;
};

export const deletePowerBiFolder = async (folderId) => {
  const res = await http.delete(`/power-bi-folders/folders/${folderId}`);
  return res.data;
};

export const updatePowerBiFolder = async (folderId, data) => {
  const res = await http.put(`/power-bi-folders/folders/${folderId}`, data);
  return res.data;
};

export const getPowerBiEmbedTokenById = async (reportId) => {
  const res = await http.get(`/power-bi/embed-token/${reportId}`);
  return res.data;
};

export const createPowerBiSection = async (data) => {
  const res = await http.post(`/power-bi-folders`, data);
  return res.data;
};

// Power BI Permission (admin only)
export const getPowerBiAvailableReports = async (params) => {
  const res = await http.get(`/power-bi-permission/reports`, { params });
  return res.data;
};

export const getPowerBiFolderReports = async (folderId, params) => {
  const res = await http.get(`/power-bi/folders/${folderId}/reports`, {
    params,
  });
  return res.data;
};

export const syncPowerBiReports = async () => {
  const res = await http.post(`/power-bi-permission/reports/sync`);
  return res.data;
};

export const getPowerBiUsers = async (params) => {
  const res = await http.get(`/power-bi-permission/users`, { params });
  return res.data;
};

export const getPowerBiAllPermissions = async () => {
  const res = await http.get(`/power-bi-permission/permissions`);
  return res.data;
};

export const getPowerBiUserPermissions = async (userId) => {
  const res = await http.get(
    `/power-bi-permission/users/${userId}/permissions`
  );
  return res.data;
};

export const getAssetFileArchive = async ({ page = 1, limit = 10, assetId, section }) => {
  const params = { page, limit };
  if (assetId) params.assetId = assetId;
  if (section) params.section = section;
  const data = await http.get("/asset-file-archive", { params });
  return data.data;
};

export const getGroupedAssetFileArchive = async ({ page = 1, limit = 10, assetId, section }) => {
  const params = { page, limit };
  if (assetId) params.assetId = assetId;
  if (section) params.section = section;
  const data = await http.get("/asset-file-archive/grouped", { params });
  return data.data;
};

export const exportAssetFileArchives = async ({ assetId, section } = {}) => {
  const params = {};
  if (assetId) params.assetId = assetId;
  if (section) params.section = section;
  const data = await http.get("/asset-file-archive/export", { params });
  return data.data;
};

export const triggerAssetFilesArchive = async (file, reason = "HDM_REFRESH") => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("reason", reason);
  const data = await http.post("/asset-file-archive/trigger", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data.data;
};

export const revertAssetFileArchive = async (id) => {
  const res = await http.post(`/asset-file-archive/${id}/revert`);
  return res.data;
};

export const updatePowerBiUserPermissions = async (userId, reportIds) => {
  const res = await http.put(
    `/power-bi-permission/users/${userId}/permissions`,
    { reportIds }
  );
  return res.data;
};

export const getPowerBiUsersWithPermissions = async (params) => {
  const res = await http.get(`/power-bi-permission/users-with-permissions`, {
    params,
  });
  return res.data;
};

export const getUserPaginatedReports = async (userId, params) => {
  const res = await http.get(`/power-bi-permission/${userId}/reports`, {
    params,
  });
  return res.data;
};

export const searchAssets = async (params) => {
  return await http.get(`/asset/search`, { params });
};

export const fetchGoogleDocuments = async (id) => {
  const data = await http.post(`/fetch-documents`, {
    id,
  });

  return data.data;
};

// document source

export const uploadKnowledgeBaseDocument = async (
  file,
  overwrite = false,
  ingest = true
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("overwrite", String(overwrite));
  formData.append("ingest", String(ingest));
  const res = await http.post(`/document-sources/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const uploadKnowledgeBaseFolder = async (files, paths) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  paths.forEach((p) => formData.append("paths[]", p));
  const res = await http.post(`/document-sources/upload-folder`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const getDocumentSources = async (
  page = 1,
  limit = 10,
  type = null,
  search = ""
) => {
  const res = await http.get(`/document-sources`, {
    params: { page, limit, type, search },
  });
  return res.data;
};

export const ingestDocumentSources = async (sourceIds) => {
  const res = await http.post(`/document-sources/ingest`, { sourceIds });
  return res.data;
};

export const addDocumentSourceLink = async (payload) => {
  const res = await http.post(`/document-sources/url`, payload);
  return res.data;
};

export const addDocumentSourceYoutube = async (payload) => {
  const res = await http.post(`/document-sources/upload/youtube`, payload);
  return res.data;
};

export const toggleDocumentSourceAutoRefresh = async (id, autoRefresh) => {
  const res = await http.patch(`/document-sources/${id}/auto-refresh`, {
    autoRefresh,
  });
  return res.data;
};

export const manualSyncDocumentSource = async (id) => {
  const res = await http.post(`/document-sources/${id}/sync`);
  return res.data;
};

export const getDocumentSourceFileUrl = async (id, download = false) => {
  const res = await http.get(`/document-sources/${id}/file`, {
    params: { download },
  });
  return res.data;
};

export const deleteDocumentSource = async (id) => {
  const res = await http.delete(`/document-sources/${id}`);
  return res.data;
};

export const addGoogleDriveFolder = async (payload) => {
  const res = await http.post(`/google-drive-folders`, payload);
  return res.data;
};
export const getGoogleDriveFolders = async (page = 1, limit = 10) => {
  const res = await http.get(`/google-drive-folders`, {
    params: { page, limit },
  });
  return res.data;
};
export const syncGoogleDriveFolder = async (id) => {
  const res = await http.post(`/google-drive-folders/${id}/sync`);
  return res.data;
};

export const deleteGoogleDriveFolder = async (id) => {
  const res = await http.delete(`/google-drive-folders/${id}`);
  return res.data;
};

// knowledge gaps

export const getKnowledgeGaps = async (
  page = 1,
  limit = 10,
  status = "open"
) => {
  const res = await http.get(`/knowledge-gaps`, {
    params: { page, limit, status },
  });
  return res.data;
};

export const createKnowledgeGap = async (payload) => {
  const res = await http.post(`/knowledge-gaps`, payload);
  return res.data;
};

export const dismissKnowledgeGap = async (id) => {
  const res = await http.patch(`/knowledge-gaps/${id}/dismiss`);
  return res.data;
};

export const deleteKnowledgeGap = async (id) => {
  const res = await http.delete(`/knowledge-gaps/${id}`);
  return res.data;
};

// Interactions

export const getInteractionAnalytics = async () => {
  const res = await http.get(`/interactions/analytics`);
  return res.data;
};

export const getInteractions = async (
  page = 1,
  limit = 10,
  rating = undefined
) => {
  const res = await http.get(`/interactions`, {
    params: { page, limit, rating },
  });
  return res.data;
};

export const getInteractionKpi = async () => {
  const res = await http.get(`/interactions/kpi`);
  return res.data;
};

export const getInteractionById = async (id) => {
  const res = await http.get(`/interactions/${id}`);
  return res.data;
};

export const getInteractionChunks = async (id) => {
  const res = await http.get(`/interactions/${id}/chunks`);
  return res.data;
};

export const exportInteractions = async (rating) => {
  const res = await http.get(`/interactions/export`, { params: { rating } });
  return res.data;
};

export const getAssetFileLogs = async (page, limit, search, assetId = "") => {
  const data = await http.get(`/asset-file-logs`, {
    params: { page, limit, search, assetId },
  });
  return data.data;
};

export const getAssetFileLogDownloadUrl = async (s3Key) => {
  const data = await http.get(`/asset-file-logs/download-url`, {
    params: { s3Key },
  });
  return data.data;
};

export const bulkStatusUploadApi = async (formData) => {
  const data = await http.post(
    `/production-report-summary-v2/bulk/status-upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data.data;
};

// ── M1 & M2 Documents ──────────────────────────────────────
export const getM1M2Documents = async (params) => {
  const res = await http.get("/m1m2-documents", { params });
  return res.data;
};

export const exportM1M2Documents = async (params) => {
  const res = await http.get("/m1m2-documents/export", { params });
  return res.data;
};

// Proforma config
export const getProformaConfig = async () => {
  const data = await http.get("/proforma-config");
  return data.data;
};

export const updateProformaConfig = async (body) => {
  const data = await http.patch("/proforma-config", body);
  return data.data;
};

// ── Master Users ──────────────────────────────────────────
export const getMasterUsers = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
}) => {
  const data = await http.get("/master-users", {
    params: { page, limit, search, status },
  });
  return data.data;
};

export const createMasterUser = async (body) => {
  const data = await http.post("/master-users", body);
  return data.data;
};

export const updateMasterUser = async (id, body) => {
  const data = await http.put(`/master-users/${id}`, body);
  return data.data;
};

export const deleteMasterUser = async (id) => {
  const data = await http.delete(`/master-users/${id}`);
  return data.data;
};

export const reactivateMasterUser = async (id) => {
  const data = await http.patch(`/master-users/${id}/reactivate`);
  return data.data;
};

// GL Documents Logs
export const getGLDocumentsLogs = async (params) => {
  const data = await http.get("/gl-documents-logs", { params });
  return data.data;
};

// P&C Documents Logs
export const getPandCDocumentsLogs = async (params) => {
  const data = await http.get("/pandc-documents-logs", { params });
  return data.data;
};

